// Shared status-color affordances for every FieldPilot status picker/select. The dot itself is the
// app-wide `StatusDot`; a status's `colorHex` always renders next to its name so the UI stays
// consistent with TakeoffPilot/RevPilot status selects.
import { STATUS_DOT_FALLBACK_COLOR, StatusDot } from "@/components/status-dot";
import { cn } from "@/lib/utils";

export { StatusDot };

/** Neutral fallback used when a status has no configured color. */
export const FIELD_PILOT_STATUS_FALLBACK_COLOR = STATUS_DOT_FALLBACK_COLOR;

/** A status color dot followed by the status name — the body of a status `SelectItem`. */
export function StatusOptionLabel({
  colorHex,
  name,
  className,
}: {
  colorHex?: string | null;
  name: string;
  className?: string;
}) {
  return (
    <span className={cn("flex min-w-0 items-center gap-2", className)}>
      <StatusDot colorHex={colorHex ?? null} />
      <span className="min-w-0 truncate">{name}</span>
    </span>
  );
}
